import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import Page from "../../components/Page";
import Sidebar from "../../components/Sidebar";
import SidebarDrawer from "../../components/SidebarDrawer";
import TeammatesDetails from "../../components/InputFields/TeammatesDetails";
import { useNavigate } from "react-router-dom";
import { url } from "../../url";
import axios from "axios";
import { createdProjectsAtom } from "../Projects/atoms/CreatedProjectAtomGlobal";
import { useAtom } from "jotai";
// import CreatedProjectBox from "../../components/Boxs/CreatedProjectBox";
// import Pagination from "@mui/material/Pagination";
import ProjectCard from "../../components/Boxs/ProjectCard";
import InfiniteScroll from "react-infinite-scroll-component";
import CircularProgress from '@mui/material/CircularProgress';
import styles from "./myProjects.module.scss";

const MyProject = () => {
  const [createdProjects, setCreatedProjects] = useAtom(createdProjectsAtom);
  // const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  // Infinite scroll
  const [hasMore, setHasMore] = useState(true);
  const [index, setIndex] = useState(2);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const myProjects = await axios.get(
        url + `/user/myProjects?page=${currentPage}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setCreatedProjects(myProjects.data.UserProjects);
      const morePages = myProjects.data.myProjectsPages == 1 ? false : true;
      if (!morePages){
        setHasMore(false);
      }
    };
    fetchData();
  }, [currentPage, setCreatedProjects]);

  const navigate = useNavigate();

  const handlePageChange = (value: number) => {
    setCurrentPage(value);
  };

  const goToCreateProject = () => {
    navigate("/project/add");
  };

  const navigateToEdit = (project: any) => {
    navigate(`/project/editProject/${project._id}`);
  };

  const fetchMoreProjects = async () => {
    await axios.get(url + `/user/myProjects?page=${currentPage}`)
    .then((res) => {
      const myProjectsArr = res.data.UserProjects;
      setCreatedProjects((prevProjects: any[]) => [...prevProjects, ...myProjectsArr]);

      myProjectsArr.length > 0 ? setHasMore(true) : setHasMore(false);
    }).catch((err) => console.error(err));
    setIndex((prevIndex) => prevIndex + 1);
  };

  const deleteMyProject = async (project: any) => {
    const token = localStorage.getItem("token");
    try {
      await axios.delete(url + "/user/myProjects", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          project_id: project._id,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Page>
      <div className="myProjects">
        <header className="myProjects__header">
          <div className="myProjects__header__sidebar">
            <SidebarDrawer />
          </div>
          {createdProjects.length > 0 && (
            <div>
              <Button
                variant="contained"
                size="small"
                onClick={() => goToCreateProject()}
                className="header-button"
              >
                Add
              </Button>
            </div>
          )}
        </header>
        <div className="myProjects__container">
          <div className="myProjects__container__sidebar">
            <Sidebar />
          </div>
          <div className="myProjects__container__savedProjects">
            {createdProjects.length === 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center' }}>
                <h2 style={{ marginBottom: '2rem', fontSize: '1.8rem', color: '#374151', fontWeight: '400' }}>No projects created yet...</h2>
                <Button
                  onClick={() => goToCreateProject()}
                  variant="contained"
                  size="large"
                  style={{
                    width: '280px',
                    height: '80px',
                    fontSize: '1.2rem',
                    fontWeight: '500',
                    borderRadius: '6px',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                    transition: 'all 0.3s ease',
                    textTransform: 'none',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                  }}
                >
                  Create Project
                </Button>
              </div>
            ) : (
              <div className={styles.gridContainer}>
                <InfiniteScroll
                  dataLength={createdProjects.length}
                  next={fetchMoreProjects}
                  hasMore={hasMore}
                  loader={<CircularProgress/>}
                  style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))', gap: '2rem' }}
                >
                {createdProjects.map((project: any) => {
                  return (
                    <div key={project._id} className={styles.projectCard}>
                      <ProjectCard
                        tokenAvailable={false}
                        project={project}
                        deleteProject={() => deleteMyProject(project)}
                        myProject={true}
                      />
                    </div>
                  );
                })}
                </InfiniteScroll>
              </div>
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default MyProject;